import { type TextMarkStruct } from '@meitu/saas-editor-core/es/layers/text-layer';

export const getTextMarkThumbnailURL = (textMark: TextMarkStruct, theme: string, isIntl: boolean) => {
    const fallback = textMark.thumbnail?.url || '';

    if (isIntl) {
        return textMark.thumbnailBlack?.url || fallback; // 海外不支持切换主题，所以用默认黑色底缩略图
    }
    // light 模式用黑色底缩略图
    return (theme === 'light' ? textMark.thumbnailBlack?.url : textMark.thumbnail?.url) || fallback;
};
